import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import DataTable from 'components/utils/DataTable';
import styles from './styles.module.css';
import Info from 'components/utils/Alert/Info';
import { Grid,IconButton } from '@mui/material';
import ShopsHelper from 'helpers/ShopsHelper';
import { ShopContext } from 'Context/ShopContext';

function VendorPurchaseDialog(props) {
  const { t: tCommon } = useTranslation('common');
  const { t: tPopup } = useTranslation('popup');
  const { shop } = useContext(ShopContext);
  const { togglePurchaseTab, rowData } = props;
  const items = rowData?.items || [];
  const columnHeader = [
    {
      id: 'plu',
      label: tCommon('PLU'),
      type: 'text',
    },
    {
      id: 'item.name',
      label: tCommon('Name'),
      type: 'text',
    },
    {
      id: 'quantity',
      label: tCommon('Quantity'),
      type: 'floatQuantity',
    },
    {
      id: 'rate',
      label: tCommon('Price'),
      type: 'floatAmount',
    },
    {
      id: 'tax',
      label: tCommon('Tax'),
      type: 'text',
    },
    {
      label: tCommon('Total'),
      id: 'total',
      type: 'callback',
      viewRender: (item) => {
        return ShopsHelper.getAmountFormatted(shop, item.quantity * item.rate + item.tax);
      },
    },
  ];

  return (
    <div className={styles.popUp}>
      <div className={styles.contentWrapper}>
        <div className={styles.headSec}>
          <h2 className={styles.editTitle}>{tCommon('Purchase Details')}</h2>
          <IconButton onClick={() => { togglePurchaseTab(null);}}>
            <CloseIcon />
          </IconButton>
        </div>
        <div className={styles.changeable} style={{ margin: '10px' }}>
          <Grid container style={{ marginTop: '5px' }} spacing={1}>
            <Grid item xs={6} sm={3}>
              <h5 className={styles.textHead}>{tCommon('Bill Date')}</h5>
            </Grid>
            <Grid item xs={6} sm={3}>
              <h5 className={styles.textValues}>{rowData?.bill_date}</h5>
            </Grid>
            <Grid item xs={6} sm={3}>
              <h5 className={styles.textHead}>{tCommon('Invoice No')}</h5>
            </Grid>
            <Grid item xs={6} sm={3}>
              <h5 className={styles.textValues}>{rowData?.invoice_no || 0}</h5>
            </Grid>
          </Grid>

          <Grid container style={{ marginTop: '5px' }} spacing={1}>
            <Grid item xs={6} sm={3}>
              <h5 className={styles.textHead}>{tCommon('Invoice Date')}</h5>
            </Grid>
            <Grid item xs={6} sm={3}>
              <h5 className={styles.textValues}>{rowData?.date}</h5>
            </Grid>
            <Grid item xs={6} sm={3}>
              <h5 className={styles.textHead}>{tCommon('Total')}</h5>
            </Grid>
            <Grid item xs={6} sm={3}>
              <h5 className={styles.textValues}>{rowData?.total_amount || 0}</h5>
            </Grid>
          </Grid>
        </div>
        <div className={styles.tableContent1}>
          {items && items.length ? (
            <DataTable columns={columnHeader} rows={rowData?.items} />
          ) : (
            <Info title={tPopup('Purchase Details not found')} content={tPopup('This Purchase have no items to list up')} />
          )}
        </div>
      </div>
    </div>
  );
}

export default VendorPurchaseDialog;
